/**
 * Application/usage text in FN Product Details: update when the PDP variant changes.
 * Prefers variant metafield foodnova.usage_variant (rich text HTML), else product
 * foodnova.daily_consumption_recommendation.
 *
 * Listens to Dawn PUB_SUB_EVENTS.variantChange and to product form input[name="id"]
 * changes (Dawn updates that input on every successful variant resolve).
 */
(function () {
  const controllers = [];
  let listenersBound = false;
  let pubsubBound = false;

  function parseData(script) {
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('[foodnova-usage] Invalid JSON data', error);
      return null;
    }
  }

  function resolveHtml(data, variantId) {
    if (!data) return '';
    const key = variantId != null ? String(variantId) : '';
    const fromVariant =
      key && data.variants && Object.prototype.hasOwnProperty.call(data.variants, key)
        ? data.variants[key]
        : '';
    if (typeof fromVariant === 'string' && fromVariant.trim() !== '') {
      return fromVariant;
    }
    if (typeof data.fallback === 'string' && data.fallback.trim() !== '') {
      return data.fallback;
    }
    return '';
  }

  function apply(block, data, variantId) {
    const valueEl = block.querySelector('[data-foodnova-usage-value]');
    if (!valueEl) return;

    const html = resolveHtml(data, variantId);
    valueEl.innerHTML = html;
    if (html.trim() !== '') {
      block.removeAttribute('hidden');
    } else {
      block.setAttribute('hidden', '');
    }
  }

  function applyAll(variantId) {
    controllers.forEach(({ block, data }) => {
      apply(block, data, variantId);
    });
  }

  function collectControllers() {
    controllers.length = 0;

    document.querySelectorAll('[data-foodnova-usage]').forEach((block) => {
      const sectionId = block.getAttribute('data-foodnova-usage-section');
      if (!sectionId) return;

      const dataScript = document.getElementById(`FoodnovaUsageData-${sectionId}`);
      const data = parseData(dataScript);
      if (!data) return;

      controllers.push({ block, data, sectionId });
    });
  }

  function readVariantIdFromProductForm() {
    const input = document.querySelector(
      'product-info form input[name="id"], product-info input[name="id"], .product-form input[name="id"]'
    );
    if (!input || !input.value) return null;
    return input.value;
  }

  function onVariantChangeEvent(event) {
    const variantId = event?.data?.variant?.id;
    if (variantId != null) {
      applyAll(variantId);
      return;
    }
    const fromForm = readVariantIdFromProductForm();
    if (fromForm != null) applyAll(fromForm);
  }

  function onFormIdChange(event) {
    const target = event.target;
    if (!target || target.name !== 'id') return;
    if (!target.closest('product-info, .product-form, product-form')) return;
    if (!target.value) return;
    applyAll(target.value);
  }

  function bindListeners() {
    if (!listenersBound) {
      document.addEventListener('change', onFormIdChange);
      listenersBound = true;
    }

    if (pubsubBound) return true;

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChangeEvent);
      pubsubBound = true;
      return true;
    }

    return false;
  }

  function boot() {
    collectControllers();
    if (!controllers.length) return;

    const initialId =
      controllers[0].data.selectedVariantId ?? readVariantIdFromProductForm();
    applyAll(initialId);

    if (bindListeners()) return;

    // pubsub may load after this deferred script in some setups; retry briefly.
    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      if (bindListeners() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
